import {
  isCurrentUserAdmin,
  isCurrentUserSuperAdmin,
} from "@risalabs_frontend_org/auth-wrapper";
import React from "react";
import ErrorPage from "../errorPage/errorPage";

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({
  children,
}) => {
  // Check if user is admin
  if (!isCurrentUserAdmin() && !isCurrentUserSuperAdmin()) {
    return <ErrorPage />;
  }

  return <>{children}</>;
};

export default ProtectedAdminRoute;
